import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GameProvider } from './context/GameContext';
import './App.css';

// Pages
import LandingPage from './pages/LandingPage';
import TabletPage from './pages/TabletPage';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import History from './pages/History';

function App() {
  return (
    <GameProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Landing Page */}
            <Route path="/" element={<LandingPage />} />

            {/* Admin Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/history" element={<History />} />
            <Route path="/login" element={<Login />} />

            {/* Tablet Interfaces */}
            <Route path="/tablet/wine-cellar" element={<TabletPage section="wine-cellar" />} />
            <Route path="/tablet/study" element={<TabletPage section="study" />} />
            <Route path="/tablet/dining-room" element={<TabletPage section="dining-room" />} />
            <Route path="/tablet/fuse-box" element={<TabletPage section="fuse-box" />} />
          </Routes>
        </div>
      </Router>
    </GameProvider>
  );
}

export default App;

